import SVG from './SVG'

export const ArrowRight = ({ color, ...props }) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      $color={color}
      {...props}
    >
      <g className="arrow_right_24l">
        <path
          fillRule="evenodd"
          d="M8.293 5.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L13.586 12 8.293 6.707a1 1 0 010-1.414z"
          className="Vector (Stroke)"
          clipRule="evenodd"
        />
      </g>
    </SVG>
  )
}
